import { IS_MOBILE } from '@repo/common-utils';
import { cva } from 'class-variance-authority';
import { FC, ReactNode } from 'react';

import { cn } from '../../../libs/utils';

/**
 * size가 있지만 TableCell 컴포넌트의 사이즈로 사용한다.
 * */
const tableVariants = cva('flex w-full box-content rounded-bzc-medium -mx-normal-small px-normal-small', {
  variants: {
    size: {
      medium: '',
      small: '',
      xsmall: ''
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});

interface TableProps {
  rowAction?: boolean;
  headerCell: ReactNode;
  contentCell: ReactNode[] | ReactNode;
  size?: 'medium' | 'small' | 'xsmall';
  className?: string;
}

export const Table: FC<TableProps> = ({ rowAction = false, contentCell, headerCell, size = 'medium', className, ...props }) => {
  return (
    <div
      className={cn(
        tableVariants({ size }),
        {
          'active:bg-neutral-background-hovered&pressed': rowAction && IS_MOBILE
        },
        { 'hover:bg-neutral-background-hovered&pressed cursor-pointer': rowAction },
        className
      )}
      {...props}
      role={'table'}
    >
      {headerCell}
      {contentCell}
    </div>
  );
};
